module.exports = {
      id: "gn-reach-icon-usage",
      viewBox: "0 0 114 36",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#gn-reach-icon",
      toString: function () {
        return this.url;
      }
    }